import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#cart").on("click", ".cart-emptyCart", this.click);
    }

    click = (event: Event) => {
        let alertText = "Really want to empty the cart?";
        switch (globalThis.lang) {
            case 'it': alertText = "Vuoi davvero svuotare il carrello?"; break;
            case 'en': break;
            case 'de': alertText = "Möchten Sie den Einkaufswagen wirklich leeren?"; break;
            case 'fr': alertText = "Vous voulez vraiment vider le panier?"; break;
            case 'es': alertText = "¿De verdad quieres vaciar el carrito?"; break;
        }
        let ok = confirm(alertText);
        if (!ok) {
            return
        }

        let data = {
            jsonrpc: "2.0",
            id: null,
        }
        net.postJSON("/j/empty-cart/", data, this.clickSuccess.bind(this))
            .fail(this.clickFail);
    }

    clickSuccess(result: JQuery.PlainObject): void {
        // Trace on analytics
        window.sa_event("empty_cart");

        location.reload();
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }
}
